import React from 'react';
import { XCircle } from 'lucide-react';

const SubscriptionError = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '40px',
        maxWidth: '500px',
        textAlign: 'center'
      }}>
        <XCircle 
          size={64} 
          color="#ff4d4f" 
          style={{ margin: '0 auto 20px' }}
        />
        
        <h1 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '16px',
          color: '#262626'
        }}>
          Subscription Error
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#595959',
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          There was an error validating your subscription. This could be due to:
        </p>
        
        <ul style={{
          textAlign: 'left',
          marginBottom: '24px',
          paddingLeft: '20px',
          color: '#595959'
        }}>
          <li style={{ marginBottom: '8px' }}>Invalid license key</li>
          <li style={{ marginBottom: '8px' }}>Module mismatch</li>
          <li style={{ marginBottom: '8px' }}>Network connectivity issues</li>
          <li style={{ marginBottom: '8px' }}>Server error</li>
        </ul>
        
        <div style={{
          backgroundColor: '#fff1f0',
          border: '1px solid #ffccc7',
          padding: '16px',
          borderRadius: '4px',
          marginBottom: '24px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#cf1322',
            margin: 0
          }}>
            Need immediate assistance?
          </p>
          <a 
            href="mailto:support@infoedmedia.com"
            style={{
              fontSize: '16px',
              color: '#cf1322',
              fontWeight: '500',
              textDecoration: 'none'
            }}
          >
            support@infoedmedia.com
          </a>
        </div>
        
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 32px',
            backgroundColor: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            fontSize: '16px',
            cursor: 'pointer',
            marginRight: '12px'
          }}
        >
          Try Again
        </button>
        
        <a 
          href="https://infoedmedia.com/shopping_cart/"
          style={{
            display: 'inline-block',
            padding: '12px 32px',
            backgroundColor: '#f0f0f0',
            color: '#262626',
            borderRadius: '4px',
            textDecoration: 'none',
            fontWeight: '500',
            fontSize: '16px'
          }}
        >
          Go to Dashboard
        </a>
      </div>
    </div>
  );
};

export default SubscriptionError;